module.exports = __webpack_public_path__ + "img/setting.ab9ee43f.png";